"use client";

import FullbackLoader from "@/components/common/Loader";

export default function Loading() {
  return <FullbackLoader />;
}
